export default "/_next/static/images/10941a7348be87deda80a870e1b7cfa4.svg";